import React from 'react';
import { CheckCircleOutlined, UpCircleOutlined, DownCircleOutlined } from '@ant-design/icons';
import { UtilizationInventoryCard } from './UtilizationInventoryCard';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import CpuSvg from '../../../assets/icons/cpu.svg?raw';
import {
    calculatePercentage,
    formatPercent,
    oversizedUndersizedState,
} from '../../SummaryWrapper/inventorySummaryHelpers';
import { formatCount } from '../../../pages/Discovery/helpers';

export const CPUUtilizationCard = ({
    optimizedByCPU,
    totalInventory,
    totalCPU,
    cpuReductionOpportunities,
    undersizedCPU,
    primaryTrend,
    oversizedTrend,
    undersizedTrend,
    isExpanded,
    onFilterClick,
    ...props
}) => (
    <UtilizationInventoryCard
        title="CPU Utilization"
        subLabelIcon={<CheckCircleOutlined />}
        subLabelIconClass="success-icon"
        subLabel="Optimized VMs"
        primaryValue={formatCount(optimizedByCPU)}
        primaryPercent={formatPercent(calculatePercentage(optimizedByCPU, totalInventory))}
        primaryTrend={primaryTrend}
        description={'Instances meeting\nperformance thresholds'}
        rows={[
            {
                variant: 'ready',
                label: 'Total Core Count',
                count: formatCount(totalCPU),
                countSuffix: 'vCPUs',
                icon: <CustomSVG svg={CpuSvg} />,
            },
            {
                variant: 'ready',
                label: 'Oversized VMs',
                count: formatCount(cpuReductionOpportunities),
                percent: formatPercent(calculatePercentage(cpuReductionOpportunities, totalInventory)),
                percentTrend: oversizedTrend,
                oversizedUndersizedState: oversizedUndersizedState(oversizedTrend),
                iconVariant: 'notReady',
                icon: <UpCircleOutlined />,
                onClick: onFilterClick ? () => onFilterClick(['oversized_cpu']) : undefined,
            },
            {
                variant: 'notReady',
                label: 'Undersized VMs',
                count: formatCount(undersizedCPU),
                percent: formatPercent(calculatePercentage(undersizedCPU, totalInventory)),
                percentTrend: undersizedTrend,
                oversizedUndersizedState: oversizedUndersizedState(undersizedTrend),
                icon: <DownCircleOutlined />,
                onClick: onFilterClick ? () => onFilterClick(['undersized_cpu']) : undefined,
            },
        ]}
        isExpanded={isExpanded}
        {...props}
    />
);
